import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'CmsDashboard',
  setup(__props) {

const Links = [
  { title: 'Add User', to: '/cms/add-user', location: 'user' },
  { title: 'Manage Users', to: '/cms/manage-users', location: 'user' },

  { title: 'Add Article', to: '/cms/add-article', location: 'news' },
  { title: 'Manage Articles', to: '/cms/manage-articles', location: 'news' },

  { title: 'Add Founders', to: '/cms/add-founders', location: 'dr-university' },
  { title: 'Manage Founders', to: '/cms/manage-founders', location: 'dr-university' },
  { title: 'Add Matchup Table', to: '/cms/add-matchup-table', location: 'dr-university' },
  { title: 'Manage Matchup Tables', to: '/cms/manage-matchup-tables', location: 'dr-university' },

  { title: 'Add GeoGuesser', to: '/cms/add-geoguesser', location: 'geoguesser' },
  { title: 'Manage GeoGuessers', to: '/cms/manage-geogussers', location: 'geoguesser' },
];

const userLinks = Links.filter((link) => link.location === 'user');
const newsLinks = Links.filter((link) => link.location === 'news');
const drUniversityLinks = Links.filter((link) => link.location === 'dr-university');
const geoGuesserLinks = Links.filter((link) => link.location === 'geoguesser');

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createBlock(_component_v_main, { class: "pa-8" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "text-center text-h4 font-weight-bold mb-10" }, "CMS Dashboard", -1)),
          _createVNode(_component_v_row, {
            class: "mb-8",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "10",
                lg: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    elevation: "4",
                    class: "pa-6"
                  }, {
                    default: _withCtx(() => [
                      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-center text-h5 font-weight-medium mb-6" }, "Users", -1)),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userLinks), (link) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              key: link.title,
                              cols: "12",
                              sm: "6",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  to: link.to,
                                  color: "primary",
                                  variant: "elevated",
                                  class: "w-100 text-none d-flex align-center justify-center",
                                  height: "56"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(link.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            class: "mb-8",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "10",
                lg: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    elevation: "4",
                    class: "pa-6"
                  }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-center text-h5 font-weight-medium mb-6" }, "News", -1)),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsLinks), (link) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              key: link.title,
                              cols: "12",
                              sm: "6",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  to: link.to,
                                  color: "#666",
                                  variant: "elevated",
                                  class: "w-100 text-none d-flex align-center justify-center",
                                  height: "56"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(link.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            class: "mb-8",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "10",
                lg: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    elevation: "4",
                    class: "pa-6"
                  }, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-center text-h5 font-weight-medium mb-6" }, "Dark Ranger University", -1)),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(drUniversityLinks), (link) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              key: link.title,
                              cols: "12",
                              sm: "6",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  to: link.to,
                                  color: "secondary",
                                  variant: "elevated",
                                  class: "w-100 text-none d-flex align-center justify-center",
                                  height: "56"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(link.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { justify: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "10",
                lg: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    elevation: "4",
                    class: "pa-6"
                  }, {
                    default: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-center text-h5 font-weight-medium mb-6" }, "GeoGuesser", -1)),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(geoGuesserLinks), (link) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              key: link.title,
                              cols: "12",
                              sm: "6",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  to: link.to,
                                  color: "green darken-1",
                                  variant: "elevated",
                                  class: "w-100 text-none d-flex align-center justify-center",
                                  height: "56"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(link.title), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})